var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-row gap-2 mb-2" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "campaigns.create",
                  expression: "'campaigns.create'",
                },
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { 400: true },
                },
              ],
              attrs: { variant: "primary" },
              on: { click: _vm.addNew },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "PlusIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.$t("AddNew"))),
              ]),
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "campaigns.approve",
                  expression: "'campaigns.approve'",
                },
              ],
              attrs: { variant: "outline-primary" },
              on: { click: _vm.goToApprovals },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "CheckSquareIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.$t("campaign.approvals"))),
              ]),
              _vm.awaitingCount > 0
                ? _c(
                    "b-badge",
                    { staticClass: "ml-50", attrs: { variant: "warning" } },
                    [_vm._v(_vm._s(_vm.awaitingCount))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("Grid", {
        attrs: {
          service: _vm.service,
          route_name: "campaigns",
          order_column: "id",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v(_vm._s(_vm.$t("campaign.name"))),
                ]),
                _c("vs-th", { key: "window" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.window"))),
                ]),
                _c("vs-th", { key: "offer" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.offer"))),
                ]),
                _c("vs-th", { key: "budget" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.budget"))),
                ]),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("campaign.status")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _vm._v(_vm._s(tr.id)),
                    ]),
                    _c("vs-td", { key: "name", attrs: { width: "28%" } }, [
                      _c("div", { staticClass: "font-medium" }, [
                        _vm._v(_vm._s(tr.name)),
                      ]),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm._.get(tr, "legal_entity.name"))),
                      ]),
                    ]),
                    _c("vs-td", { key: "window", attrs: { width: "17%" } }, [
                      _c("small", [_vm._v(_vm._s(_vm.windowLabel(tr)))]),
                    ]),
                    _c("vs-td", { key: "offer", attrs: { width: "20%" } }, [
                      _c("small", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("campaign.discount")) +
                            ": " +
                            _vm._s(
                              _vm.amountLabel(
                                tr.discount_type,
                                tr.discount_amount
                              )
                            )
                        ),
                        _c("br"),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("campaign.commission")) +
                            ": " +
                            _vm._s(
                              _vm.amountLabel(
                                tr.commission_type,
                                tr.commission_amount
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("vs-td", { key: "budget", attrs: { width: "15%" } }, [
                      tr.budget_cap_cents
                        ? _c("small", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.money(tr.budget_spent_cents)) +
                                " / " +
                                _vm._s(_vm.money(tr.budget_cap_cents)) +
                                " "
                            ),
                          ])
                        : _c("small", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(_vm.$t("campaign.no_budget_cap"))),
                          ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "10%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.statusColor(tr.status),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("campaign.status_." + tr.status)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.show",
                                expression: "'campaigns.show'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-primary",
                            attrs: { icon: "EyeIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(props.data[indextr].id)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.edit",
                                expression: "'campaigns.edit'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function ($event) {
                                return props.edit(props.data[indextr].id)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.delete",
                                expression: "'campaigns.delete'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function ($event) {
                                return props.destroy(props.data[indextr])
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }